import React, { useState, useEffect } from "react";
import { message } from "antd";
import {
  getTypes,
  getOffresByType,
  updateAverageAmount,
} from "../../../services/average/offresApi";

const AverageAmountManager = () => {
  const [types, setTypes] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [offres, setOffres] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAverage, setCurrentAverage] = useState(null);
  const [formValues, setFormValues] = useState({
    coins_base: "",
    montant_base: "",
    promotion: 0,
  });

  useEffect(() => {
    const loadTypes = async () => {
      setLoading(true);
      try {
        const response = await getTypes();
        if (Array.isArray(response)) {
          setTypes(response);
        } else {
          message.error("Format inattendu des types");
        }
      } catch (error) {
        message.error("Erreur chargement types");
      } finally {
        setLoading(false);
      }
    };
    loadTypes();
  }, []);

  //   useEffect(() => {
  //     if (selectedType) {
  //       const loadOffres = async () => {
  //         setLoading(true);
  //         try {
  //           const response = await getOffresByType(selectedType);
  //           setOffres(response.offres || []);
  //           setCurrentAverage(response.average || null);

  //           if (response.average) {
  //             setFormValues({
  //               coins_base: response.average.coins_base / 1000 + 'k',
  //               montant_base: response.average.montant_base,
  //               promotion: response.average.promotion || 0
  //             });
  //           } else {
  //             setFormValues({ coins_base: '', montant_base: '', promotion: 0 });
  //           }
  //         } catch (error) {
  //           message.error('Erreur chargement offres');
  //         } finally {
  //           setLoading(false);
  //         }
  //       };
  //       loadOffres();
  //     }
  //   }, [selectedType]);
  useEffect(() => {
    if (selectedType) {
      const loadOffres = async () => {
        setLoading(true);
        try {
          const response = await getOffresByType(selectedType);
          setOffres(response.offres || []);
          setCurrentAverage(response.average || null);

          // Trouver l'offre avec le plus petit coins
          const offres = response.offres || [];
          let smallestOffer = null;
          if (offres.length > 0) {
            smallestOffer = offres.reduce(
              (min, offre) => (offre.coins < min.coins ? offre : min),
              offres[0]
            );
          }

          if (smallestOffer) {
            setFormValues({
              coins_base: smallestOffer.coins / 1000 + "k",
              montant_base: smallestOffer.montant,
              promotion: smallestOffer.promotion || 0,
            });
          } else if (response.average) {
            setFormValues({
              coins_base: response.average.coins_base / 1000 + "k",
              montant_base: response.average.montant_base,
              promotion: response.average.promotion || 0,
            });
          } else {
            setFormValues({ coins_base: "", montant_base: "", promotion: 0 });
          }
        } catch (error) {
          message.error("Erreur chargement offres");
        } finally {
          setLoading(false);
        }
      };
      loadOffres();
    }
  }, [selectedType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const coinsBase = parseInt(formValues.coins_base.replace("k", "")) * 1000;

      await updateAverageAmount({
        type_id: selectedType,
        coins_base: coinsBase,
        montant_base: parseFloat(formValues.montant_base),
        promotion: parseFloat(formValues.promotion) || 0,
      });

      message.success("Configuration mise à jour");

      const response = await getOffresByType(selectedType);
      setOffres(response.offres || []);
      setCurrentAverage(response.average || null);
    } catch (error) {
      message.error("Erreur mise à jour");
    }
  };

  return (
    <div className="container mt-4">
      <h3 style={{ color: "var(--primary-color3) !important" }}>
        Configuration des Prix par Type
      </h3>
      <div className="form-group mb-3">
        <p style={{ color: "var(--primary-color3) !important" }}>
          Type d'offre
        </p>
        <select
          style={{ fontSize: "1.2rem", padding: "12px 24px" }}
          className="form-control"
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
        >
          <option value="">-- Sélectionner un type --</option>
          {types.map((type) => (
            <option key={type.id} value={type.id}>
              {type.nom}
            </option>
          ))}
        </select>
      </div>

      {selectedType && (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-4 mb-3">
              <label style={{ color: "var(--primary-color3) !important" }}>
                Coins de base
              </label>
              <input
                disabled
                type="text"
                style={{
                  fontWeight: "bold",
                  color: "black",
                  backgroundColor: "#fff",
                }}
                className="form-control"
                name="coins_base"
                value={formValues.coins_base}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4 mb-3">
              <label style={{ color: "var(--primary-color3) !important" }}>
                Montant de base ($)
              </label>
              <input
                type="number"
                className="form-control"
                name="montant_base"
                value={formValues.montant_base}
                step="0.01"
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-4 mb-3">
              <label style={{ color: "var(--primary-color3) !important" }}>
                Promotion (%)
              </label>
              <input
                type="number"
                className="form-control"
                name="promotion"
                value={formValues.promotion}
                onChange={handleChange}
                min="0"
                max="100"
              />
            </div>
          </div>

          <button
            type="submit"
            style={{ fontSize: "1.2rem", padding: "12px 24px" }}
            className="btn btn-primary"
          >
            {currentAverage ? "Mettre à jour" : "Créer"} la configuration
          </button>
        </form>
      )}

{selectedType && (
  <div className="mt-5">
    <h4 className="mb-4" style={{ color: "var(--primary-color3)" }}>
      Offres pour le type{" "}
      {types.find((t) => t.id === selectedType)?.nom || ""}
    </h4>
    <div className="table-responsive shadow-sm rounded">
      <table className="table table-striped table-hover align-middle mb-0 bg-white">
        <thead className="table-dark">
          <tr>
            <th>Titre</th>
            <th>Coins</th>
            <th>Montant Avant Promo ($)</th>
            <th>Promotion (%)</th>
            <th>Montant Final ($)</th>
          </tr>
        </thead>
        <tbody>
          {offres.map((offre) => {
            const promotion = offre.promotion || 0;
            // Ensure finalPrice is a number by using Number() or parseFloat()
            const finalPrice = Number(offre.montant) || 0;

            // Calcul ancien montant réel avant promo
            const oldPrice =
              promotion > 0 ? finalPrice / (1 - promotion / 100) : finalPrice;

            return (
              <tr key={offre.id}>
                <td>{offre.titre}</td>
                <td>{offre.coins}</td>
                <td style={{ textDecoration: promotion > 0 ? "line-through" : "none", color: "#dc3545" }}>
                  ${oldPrice.toFixed(2)}
                </td>
                <td>{promotion}%</td>
                <td
                  style={{
                    fontWeight: "bold",
                    color: promotion > 0 ? "#28a745" : "#6c757d",
                  }}
                >
                  ${finalPrice.toFixed(2)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
)}


    </div>
  );
};

export default AverageAmountManager;
